import styled from "styled-components";
export const ToastWrapper = styled.div`
  position: relative;
  bottom: 20px;
  right: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 13px;
  min-width: 450px;
  // max-width: 600px;
  z-index: 2500;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NotificationHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ToastIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

export const StatusText = styled.div`
  font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 0.813rem;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
  color: #48566B;
`;

export const ProgressText = styled.div`
  font-family: 'Manrope', sans-serif;
font-weight: 400;
font-size: 11px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
color:#5A6C87;
margin-top:12px;
`;